import React from 'react';
import './Thankyou.css'
import StaggeredMenu from '../Components/Layout/StaggeredMenu';
import SectionLabel from '../Components/Common/SectionLabel';
import HeroText from '../Components/Common/HeroText';
import { triggerConfetti } from '../Confetti';

import Qr from '../Assets/Imgs/QR.svg';
import Btn from '../Components/Common/Btn';
import Footer from '../Components/Layout/Footer';


const Thankyou = () => {

    const menuItems = [
        { label: 'Home', ariaLabel: 'Go to home page', link: '/' },
        { label: 'Booking', ariaLabel: 'Book your visit', link: '/booking' },
        { label: 'Gallery', ariaLabel: 'Take a peek at our past events', link: '/gallery' }
      ];

      const handleComplete = () => {
  // ... your ticket logic
            triggerConfetti();
            };

            handleComplete();
    return ( <>

         <StaggeredMenu
                     position="right"
                     items={menuItems}
                     displaySocials
                     displayItemNumbering={true}
                     menuButtonColor="#3A3A3A"
                     openMenuButtonColor="#3A3A3A"
                     changeMenuColorOnOpen={true}
                     colors={['#35A44F', '#21FF55']}
                     logoUrl='../Assets/Imgs/Logo.svg'
                     accentColor="#35A44F"
                     onMenuOpen={() => console.log('Menu opened')}
                     onMenuClose={() => console.log('Menu closed')}
                 />   

        <main className='Thankyou'>

        
            <div className='ThanksContent'>
                <SectionLabel SectionLabel="Thank You / <3" />

                 <HeroText
                                        text="Thanks!"
                                        flex
                                        alpha={false}
                                        stroke={false}
                                        width
                                        weight
                                        italic
                                        textColor="#35A44F"
                                        strokeColor="#5227FF"
                                        minFontSize={64}
                                        fontSize={128}
                                    />    

                <p className='ThanksSub'>Thank you for booking your visit to EVs Electrify! Egypt. Your ticket has been confirmed and the details have been sent to your email.</p>   

                <div className='Ticket'>
                    <div className='Top'>
                        <div className='TickHeader'>
                            <p className='TicketTitle'>EVs Electrify! Egypt</p>
                            <div className='TicketDiv'>
                                <p className='DivTitle'>
                                    TICKET NO.
                                </p>
                                <p className='DivContent'>
                                    #EV-84729
                                </p>
                            </div>
                        </div>

                        <div className='TickInfo'>
                            <div className='TicketDiv'>
                                <p className='DivTitle'>
                                    Attendee
                                </p>
                                <p className='DivContent'>
                                    Name Name
                                </p>
                            </div>

                            <div className='TicketDiv'>
                                <p className='DivTitle'>
                                    Date & Time
                                </p>
                                <p className='DivContent'>
                                    Oct 15, 2026 • 10:00 AM
                                </p>
                            </div>
                        </div>

                        <div className='TickLoc'>
                            <div className='TicketDiv'>
                                <p className='DivTitle'>
                                    Location
                                </p>
                                <p className='DivContent'>
                                    Main Exhibition Hall, Cairo International Convention Centre
                                </p>
                            </div>
                        </div>
                        
                    </div>

                    <div className='BottomTick'>
                        <p className='TicketP'>
                            Please present this digital ticket or the QR code at the entrance for scanning. A copy has been sent to ahmed.hassan@example.com.
                        </p>

                        <img src={Qr} alt="QR Code" />
                    </div>

                    <div className='Cutout1'></div>
                    <div className='Cutout2'></div>
                </div>

                <div className='ThanksBtns'>
                    <Btn BtnText="Download Ticket" className="Download" BtnPath="#" />
                    <Btn BtnText="Go Back" className="ContactBtn" BtnPath="/" />
                </div>
            </div>

            
        </main>

        <Footer />
    </> );
}
 
export default Thankyou;